// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"93":"Character","268":"Home"}[chunkId] + "." + {"93":"7d5aa7cb","268":"c2c1f964"}[chunkId] + ".css";
};